// extracted by mini-css-extract-plugin
export default {"root":"FPmb1","content":"vJti8","defaultScreen":"XyQLh","title1":"qq91z","title2":"nBhmk","list":"WHWRs","loginButton":"ZBlxr"};